<template>
    <div class="vue-marker-mini-card" @click="handleClick">
        <div class="row mx-0 d-flex align-center justify-content-center">
            <div class="distance col-auto pl-0 pr-4 d-inline-flex flex-column align-items-center justify-content-center" v-if="hasDistance">
                <span class="kilometers font-weight-bold">{{ marker.distanceFormatted }}</span>
                <span class="unit">km</span>
            </div>

            <div class="col pl-0">
                <h5 class="mb-0">{{ marker.title }}</h5>
                <p>{{ marker.streetNumber }}</p>

                <div class="office-hours-mini">
                    <template v-if="isOpen && closingHour">
                        <span class="font-weight-bold">{{ openText }}</span>
                        {{ untilText }} {{ closingHour }}
                    </template>

                    <template v-else>
                        {{ closedText }}
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import translations from "../../../../../themes/custom/ef2_custom/js/vue/mixins/translations";

export default {
    name: "MarkerMiniCard",

    mixins: [translations],

    props: {
        marker: {
            type: Object,
            required: true
        },
        isHomePage: {
            type: Boolean,
        },
        eventBus: {}
    },

    computed: {
        isOpen() {
            return this.marker.openingHours.isOpen;
        },

        closingHour() {
            let activeDay = _.find(this.marker.openingHours.days, (day) => {
                return day.active === true;
            });

            if (_.isEmpty(activeDay.slots)) {
                return false;
            }

            return _.last(activeDay.slots).closed;
        },

        hasDistance() {
            return !_.isNil(this.marker.distanceFormatted);
        }
    },

    methods: {
        handleClick() {
            this.$emit('marker-clicked', this.marker.geoLocation);
            this.$emit('active-marker', this.marker);
            this.changePageMeta();
        },

        changePageMeta() {
            if (this.isHomePage) {
                return;
            }

            let newPageTitle = this.marker.title + ' | PartsPoint';
            document.title = newPageTitle;
            window.history.pushState({}, newPageTitle, window.location.origin + this.marker.url);
        }
    }
}
</script>